{
  "id": 2,
  "location": "cafe",
  "difficulty": "easy",
  "moves": 10,
  "kinds": 4,
  "goals": [
    { "type": "collect", "kind": "cupcake", "count": 60 }
  ],
  "stars": [12230, 17390],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 1, "movesLeft": 5.8, "closeLosses": 0, "target": 0.99 }
}
